import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Image } from '@mantine/core';
//below:image imports
import crypto_symbols from '../assets/crypto_symbols.jpg'
import koenigsegg from '../assets/koenigsegg.jpg'
import pagani from '../assets/pagani.jpg'
import mustangs_rear from '../assets/mustangs_rear.jpg'
import porsche from '../assets/porsche.jpg'
import thunderbird_tail_light from '../assets/thunderbird_tail_light.jpg'
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg'


//trying react-image gallery (if good will replace the current carousel library)

export class ResponsiveCarouselCard extends Component {
    render() {
        return (
            <Carousel showStatus={false} showThumbs={false}>
                <div>
                    <Image withPlaceholder src={mustangs_rear} alt="mustangs_rear" />
                </div>
                <div>
                    <Image withPlaceholder src={koenigsegg} alt="koenigsegg" />
                </div>
                <div>
                    <Image withPlaceholder src={pagani} alt="pagani" />
                </div>
                <div>
                    <Image withPlaceholder src={porsche} alt="porsche" />
                </div>
                <div>
                    <Image withPlaceholder src={thunderbird_tail_light} alt="thunderbird_tail_light" />
                </div>
                <div>
                    <Image withPlaceholder src={black_and_white_mercedes_benz} alt="black_and_white_mercedes_benz" />
                </div>
            </Carousel>
        );
    }
}


// Don't forget to include the css in your page

// Using webpack or parcel with a style loader
// import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';

// Using html tag:
// <link rel="stylesheet" href="<NODE_MODULES_FOLDER>/react-responsive-carousel/lib/styles/carousel.min.css"/>
